import {proofImageUrl} from '~/utils/url';

export function deserializeSavedDesigns(
  data,
  imageSize = 'front_small_extended'
) {
  const result = {
    designs: []
  };

  data.designs.forEach(designResult => {
    const {composite_id, products, design_name, updated_at} = designResult;
    const productId = products[0]['product_id'];
    result.designs.push({
      products,
      compositeId: composite_id,
      productId,
      designName: design_name,
      designDigest: updated_at,
      imageSrc: proofImageUrl(productId, composite_id, updated_at, imageSize)
    });
  });

  return result;
}
